import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { MedidaCautelarService } from 'src/app/dashboard/services/medida-cautelar.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CustomValidators } from 'src/app/shared/custom-validator/custom-validator.component';

@Component({
  selector: 'app-add-medida-cautelar',
  templateUrl: './add-medida-cautelar.component.html',
  styleUrls: ['./add-medida-cautelar.component.css']
})
export class AddMedidaCautelarComponent implements OnInit {

  validatingForm: FormGroup;
  constructor(private apiService: MedidaCautelarService, private auth: AuthService, private router: Router, private toastr: ToastrService, private translate: TranslateService) { }

  ngOnInit() {
    let language = this.auth.getLanguage();
    if (language == "" || language == null) {
      language = 'es';
    }
    this.translate.setDefaultLang(language);

    this.validatingForm = new FormGroup({
      signupFormModalName: new FormControl('', [
        Validators.required,
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ.,()\-_\[\]\/"']{2,255}$/), // control más estricto y amigable
        CustomValidators.secureInput
      ]),
      signupFormModalId: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9_-]{1,100}$/),
        CustomValidators.secureInput
      ]),
      contactFormModalMessage: new FormControl('', [
        Validators.maxLength(4000),
        CustomValidators.secureInput
      ]),
      abogado: new FormControl('', [
      ]),
    });
  }

  get signupFormModalName() {
    return this.validatingForm.get('signupFormModalName');
  }

  get signupFormModalId() {
    return this.validatingForm.get('signupFormModalId');
  }

  get contactFormModalMessage() {
    return this.validatingForm.get('contactFormModalMessage');
  }


  addMedidaCautelar() {
    if (this.validatingForm.invalid) {
      this.toastr.error(this.translate.instant('texto_56'), this.translate.instant('texto_815'));
      return;
    }
    let language = this.auth.getLanguage();
    if (language == "" || language == null) {
      language = 'es';
    }
    this.translate.setDefaultLang(language);

    this.apiService.addCaution(this.auth.getSociedad(), this.signupFormModalId.value, this.signupFormModalName.value, this.contactFormModalMessage.value, language).subscribe(
      res => {
        if ((res as any).success === true) {
          this.toastr.success(this.translate.instant('texto_320'), this.translate.instant('texto_322'));
        } else {
          this.toastr.error(this.translate.instant('texto_321'), this.translate.instant('texto_813'));
        }

        this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/dashboard/layout/medida-cautelar']);
        });
      },
      err => {
        if (err.status === 409) {
          this.toastr.error(this.translate.instant('texto_321'), this.translate.instant('texto_813'));
        } else {
          this.toastr.error(this.translate.instant('texto_321'), this.translate.instant('texto_813'));
        }
      });
  }



}
